export default __webpack_public_path__ + "static/media/Architecture.f46d927f.png";